<template>
    <vue-scroll v-if="settings">
        <div class="page-header">
            <h1>Shipping</h1>
            <el-form class="mt-20">
                <el-form-item
                    label="Shipping Markup"
                    :class="form.state('shipping_markup')"
                    required
                >
                    <span slot="label">
                        Shipping Markup Percent
                        <span class="text-small"
                            >(Enter markup as decimal up to 2 places, ex: enter
                            2% as 0.02.)</span
                        >
                    </span>
                    <br />
                    <el-input-number
                        name="shipping_markup"
                        :step="0.01"
                        :min="0"
                        :disabled="!can(Permissions.EDIT_SHIPPING)"
                        v-model.number="form.shipping_markup"
                    />
                    <form-feedback :form="form" field="shipping_markup" />
                </el-form-item>
                <el-form-item
                    label="Per-Box Markup"
                    :class="form.state('handling_per_box_markup')"
                    required
                >
                    <span slot="label">
                        Per-Box Markup
                        <span class="text-small"
                            >(Fixed amount added per package)</span
                        >
                    </span>
                    <br />
                    <el-input-number
                        name="handling_per_box_markup"
                        :step="0.01"
                        :min="0"
                        :disabled="!can(Permissions.EDIT_SHIPPING)"
                        v-model.number="form.handling_per_box_markup"
                    />
                    <form-feedback
                        :form="form"
                        field="handling_per_box_markup"
                    />
                </el-form-item>
                <h4 class="mt-30">Shipping From Address</h4>
                <div style="max-width: 500px">
                    <el-form-item
                        required
                        label="Street"
                        :class="form.state('shipping_from_address.street')"
                    >
                        <el-input
                            v-validate="'required'"
                            name="shipping_from_address.street"
                            data-vv-as="street"
                            :readonly="!can(Permissions.EDIT_SHIPPING)"
                            v-model="form.shipping_from_address.street"
                        />
                        <form-feedback
                            :form="form"
                            field="shipping_from_address.street"
                        />
                    </el-form-item>
                    <el-form-item
                        required
                        label="City"
                        :class="form.state('shipping_from_address.city')"
                    >
                        <el-input
                            v-validate="'required'"
                            name="shipping_from_address.city"
                            data-vv-as="city"
                            :readonly="!can(Permissions.EDIT_SHIPPING)"
                            v-model="form.shipping_from_address.city"
                        />
                        <form-feedback
                            :form="form"
                            field="shipping_from_address.city"
                        />
                    </el-form-item>
                    <el-form-item
                        required
                        label="State"
                        :class="form.state('shipping_from_address.state')"
                    >
                        <state-select
                            data-vv-as="state"
                            name="shipping_from_address.state"
                            v-validate="'required'"
                            :disabled="!can(Permissions.EDIT_SHIPPING)"
                            v-model="form.shipping_from_address.state"
                        />
                        <form-feedback
                            :form="form"
                            field="shipping_from_address.state"
                        />
                    </el-form-item>
                    <el-form-item
                        required
                        label="Zip"
                        :class="form.state('shipping_from_address.zip')"
                    >
                        <el-input
                            v-validate="'required'"
                            name="shipping_from_address.zip"
                            data-vv-as="zip"
                            :readonly="!can(Permissions.EDIT_SHIPPING)"
                            v-model="form.shipping_from_address.zip"
                        />
                        <form-feedback
                            :form="form"
                            field="shipping_from_address.zip"
                        />
                    </el-form-item>
                </div>
                <el-button
                    :loading="form.busy"
                    @click="submit()"
                    icon="mdi mdi-content-save"
                    type="primary"
                    v-if="can(Permissions.EDIT_SHIPPING)"
                >
                    Save Changes
                </el-button>
            </el-form>
        </div>
    </vue-scroll>
</template>

<script>
import auth from "@/mixins/auth";
import unsaved_changes_mixin from "@/mixins/unsaved-changes";

export default {
    mixins: [unsaved_changes_mixin, auth],
    beforeRouteEnter(to, from, next) {
        axios.get(`/web-api/setting`).then((response) => {
            next((vm) => vm.setData(response));
        });
    },
    data() {
        return {
            form: null,
            settings: null
        };
    },
    methods: {
        getCleanFormData() {
            return JSON.stringify(
                _.pick(this.form, [
                    "shipping_markup",
                    "handling_per_box_markup",
                    "shipping_from_address"
                ])
            );
        },
        setData(response) {
            this.settings = response.data;
            this.form = new Form(this.settings, this.veeErrors);
            this.initOldData();
        },
        submit() {
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    return;
                }
                window.App.put(`/web-api/setting`, this.form).then(() => {
                    this.$notify.success({
                        message: `Changes have been saved.`
                    });
                    this.initOldData();
                });
            });
        }
    }
};
</script>

<style scoped></style>
